import { vModelText as _vModelText, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-range-slider" }
const _hoisted_2 = ["min", "max", "step"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "app-range-slider__dot" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "app-range-slider__dot" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "app-range-slider__dot" }, null, -1)
const _hoisted_6 = { class: "app-range-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", _mergeProps({
        type: "range",
        min: _ctx.min,
        max: _ctx.max,
        step: _ctx.step
      }, _ctx.$attrs, {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event))
      }), null, 16, _hoisted_2), [
        [_vModelText, _ctx.inputValue]
      ]),
      _hoisted_3,
      _hoisted_4,
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "description-min")
      ]),
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "description-max")
      ])
    ])
  ], 64))
}